export default "/fonts/fa-solid-900.ttf?b1a653db79258eeccc5d0bb8726f6600";